{
  "loadFailed": "获取支付信息失败",
  "paymentCompleted": "交易完成",
  "unverifiedTradeFailed": "交易失败，非实名交易，如有疑虑请洽平台客服",
  "paymentFailed": "支付失败",
  "confirmPayment": "确认支付",
  "myBalance": "我的余额",
  "bonusBalance": "奖励余额",
  "totalPayable": "可支付总额",
  "insufficientAvailableBalance": "您的可用余额不足"
}
